import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import { point } from '@turf/helpers';
import type { Feature, Geometry, MultiPolygon, Polygon } from 'geojson';
import type { MapLocation } from './types';

function isPolygonal(g: Geometry): g is Polygon | MultiPolygon {
  return g.type === 'Polygon' || g.type === 'MultiPolygon';
}

/** True if the location coordinates lie inside the given polygon / multipolygon geometry. */
export function locationInsideGeometry(loc: MapLocation, geometry: Geometry | null | undefined): boolean {
  if (!geometry || !isPolygonal(geometry)) {
    return false;
  }
  const pt = point([loc.map_data.lon, loc.map_data.lat]);
  const polyFeature: Feature<Polygon | MultiPolygon> = {
    type: 'Feature',
    geometry,
    properties: {},
  };
  return booleanPointInPolygon(pt, polyFeature);
}
